export default __webpack_public_path__ + "static/media/leg-right-inside.4ae87063.png";